<div class="card card-flush h-md-100">
  <!--begin::Header-->
  <div class="card-header pt-7">
    <!--begin::Title-->
    <!-- <h3 class="card-title align-items-start flex-column">
      <span class="card-label fw-bold text-gray-800"
        ><strong>{{ title }}</strong> Wallets</span
      >

      <span class="text-gray-400 mt-1 fw-semibold fs-6"
        >{{ walletsList.length }} Wallets</span
      >
    </h3> -->
    <!--end::Title-->

    <!--begin::Toolbar-->
    <div class="card-toolbar">
      <app-grid-list-changer
        [(isListView)]="isListView"
      ></app-grid-list-changer>
    </div>
    <!--end::Toolbar-->
  </div>
  <!--end::Header-->

  <!--begin::Body-->
  <div class="card-body pt-6">
    <ng-container *ngIf="isListView; else gridView">
      <!--begin::Table container-->
      <div class="table-responsive">
        <!--begin::Table-->
        <table class="table table-row-dashed align-middle gs-0 gy-3 my-0">
          <!--begin::Table head-->
          <thead>
            <tr class="fs-7 fw-bold text-gray-400 border-bottom-0">
              <th class="pe-5 pb-3 min-w-175px text-start">TRANSACTION</th>
              <th class="ps-12 pb-3 min-w-175px pe-12">DESCRIPTION</th>
              <th class="p-0 pb-3 w-50px text-end">VIEW</th>
            </tr>
          </thead>
          <!--end::Table head-->

          <!--begin::Table body-->
          <tbody>
            <ng-container *ngFor="let transaction of transactionsList; let i = index">
              <app-transaction-list-item [transaction]="transaction"></app-transaction-list-item>
            </ng-container>
          </tbody>
          <!--end::Table body-->
        </table>
      </div>
      <!--end::Table-->
    </ng-container>

    <ng-template #gridView>
      <div class="row">
        <div class="col-4">
          <!-- Wallet 1 -->
        </div>
        <div class="col-4">
          <!-- Wallet 2 -->
        </div>
        <div class="col-4">
          <!-- Wallet 3 -->
        </div>
        <!-- ... repeat for other wallets -->
      </div>
    </ng-template>
  </div>
  <!--end: Card Body-->
</div>
